import React, { useState } from 'react';
import './FAQ.css';

const FAQ_DATA = [
  {
    q: "WHERE ARE YOU BASED?",
    a: "We are based in Durban, South Africa. We ship nationwide so no matter where you are — Joburg, Cape Town, Pretoria or anywhere in between — we will get your pair to your door. Local Durban customers also have the option to collect in person."
  },
  {
    q: "HOW LONG DOES DELIVERY TAKE?",
    a: "We ship nationwide across South Africa. Most orders arrive within 2–4 business days depending on your location. Once your order is confirmed and payment is arranged, we get it moving immediately."
  },
  {
    q: "HOW DOES THE ORDERING PROCESS WORK?",
    a: "Simply add your pair to cart, go through checkout and fill in your details. No online payment is taken — once we receive your order we will contact you directly via WhatsApp or email to confirm availability, arrange payment, and sort delivery."
  },
  {
    q: "WHAT PAYMENT METHODS DO YOU ACCEPT?",
    a: "We currently accept EFT and cash on collection for local Durban customers. All payment details will be sent to you directly once your order is confirmed by our team."
  },
  {
    q: "CAN I RETURN OR EXCHANGE A PAIR?",
    a: "Returns or exchanges are strictly accepted within 7 days of delivery only if the sneakers are damaged on arrival or if there is a sizing issue. Sizing exchanges are subject to stock availability, and a return for a refund will only be processed if your required size is out of stock. To qualify, all items must be unworn, in their original packaging, and in the same condition they were delivered, though limited and hype releases remain final sale. Please contact us via DM on Instagram with your order details to initiate the process."
  },
  {
    q: "WHAT SIZES DO YOU CARRY?",
    a: "We stock UK sizes 4 through UK 15 across most silhouettes, though availability varies per drop. Each product listing shows live stock so you always know exactly what is available before you order."
  },
  {
    q: "DO YOU RESTOCK SOLD OUT PAIRS?",
    a: "Restocks are rare and depend entirely on supplier availability. The best way to stay ahead is to follow us on Instagram at @sa_dropped where we announce new stock and surprise drops first."
  },
  {
    q: "CAN I COLLECT IN PERSON?",
    a: "Yes — if you are based in Durban you are welcome to collect in person. Reach out to us on Instagram to arrange a collection time and location."
  },
  {
    q: "HOW DO I CONTACT YOU?",
    a: "The fastest way to reach us is through our Instagram @sa_dropped. We respond to DMs quickly and are always happy to help with sizing advice, availability questions, or anything else you need before copping."
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? -1 : i);

  return (
    <section className="faq">
      <div className="faq__inner">

        {/* Left — sticky header */}
        <div className="faq__left">
          <p className="faq__eyebrow">G e t &nbsp; T h e &nbsp; F a c t s</p>
          <h2 className="faq__title">COMMONLY<br />DROPPED</h2>
          <p className="faq__sub">
            Everything you need to know before you cop. Can't find your answer?
            Hit us on Instagram — we respond fast.
          </p>
          <div className="faq__badge">
            <span className="faq__badge-num">{FAQ_DATA.length}</span>
            <span className="faq__badge-lbl">Questions<br />answered</span>
          </div>
        </div>

        {/* Right — accordion */}
        <div className="faq__right">
          <div className="faq__list">
            {FAQ_DATA.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className={`faq__item${isOpen ? ' faq__item--open' : ''}`}
                  onClick={() => toggle(i)}
                >
                  <div className="faq__question">
                    <span className="faq__num">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="faq__q-text">{item.q}</span>
                    <span className="faq__icon">
                      <svg
                        width="18" height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="faq__chevron"
                      >
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                    </span>
                  </div>

                  <div className="faq__answer">
                    <div className="faq__answer-inner">
                      <p>{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
}